export default "__VITE_ASSET__4ZU73JyY__"